<template>
  <div>
    <!-- Always reserve navbar + content wrapper. The 0.97 CLS shift at
         t~520ms came from this whole tree appearing only after auth resolved. -->
    <MainHeader v-if="useAuthStore().isLoggedIn" />
    <!-- Same fixed-top + h-14 as MainHeader so the in-flow content below
         stays at the same y-coord when auth resolves and MainHeader replaces
         this placeholder. -->
    <div
      v-else
      class="fixed top-0 left-0 w-full z-[1200] h-14 border-b border-gray-200 bg-white"
    />
    <div class="min-h-screen pt-14">
      <slot v-if="useAuthStore().isLoggedIn" />
      <div
        v-else
        v-loading="true"
        class="w-full h-96"
      />
    </div>

    <template v-if="useAuthStore().isLoggedIn">
      <Modal />
      <MainSettingsDialog />
      <UserPasswordChangeDialog />
      <UserCreateDialog />
      <UserEditDialog />
      <WorkspaceCreateDialog />
      <WorkspaceTaxSettingsDialog />
      <EventChangePlanDialog />
      <EventDuplicateTemplateDialog />
      <PlansDialog />
      <PlanEditDialog />
      <PlanCreateDialog />
      <AddonsDialog />
      <AddonCreateDialog />
      <AddonEditDialog />
      <AddonCreditSetEditDialog />
      <FakturoidWorkspaceDialog />
      <FakturoidEventDialog />
    </template>
  </div>
</template>

<script setup>
// Refs
const i18n = useI18n();

// Computed
const title = computed(() => {
  if (useRoute()?.meta?.title) {
    return `${typeof useRoute().meta.title === 'function' ? useRoute().meta.title() : useRoute().meta.title} | Attendu`;
  }

  return 'Attendu';
});
useSeoMeta({
  title,
  ogTitle: title,
});

// Lifecycle
onMounted(async() => {
  if (useAuthStore().user && !useAuthStore()?.user?.locale) { // save user locale if not set
    await useUsersStore().updateUserMe({
      locale: i18n?.locale?.value,
    });
    await useAuthStore().fetchUser();
  }

  useProductsStore().fetchPrices();
  useProductsStore().fetchSubscriptionConfigs();
  useProductsStore().fetchBillingCurrencies();

  // Opening the console is what rebuilds the events and workspaces catalogue,
  // not a cron, so a sweep of every tenant runs only when staff are looking.
  if (useAuthStore().hasRole(['admin', 'support', 'developer'])) {
    useCatalogStore().request('post');
  }
});

// Watchers
watch(() => useAuthStore()?.user?.locale, (locale) => { // () => useRoute().path
  if (locale) {
    i18n.setLocale(locale);
    i18n.locale.value = locale;
  }
}, { immediate: true });
</script>
